import { render, staticRenderFns } from "./DNoRf.vue?vue&type=template&id=6f201506&scoped=true"
import script from "./DNoRf.vue?vue&type=script&lang=js"
export * from "./DNoRf.vue?vue&type=script&lang=js"
import style0 from "./DNoRf.vue?vue&type=style&index=0&id=6f201506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f201506",
  null
  
)

export default component.exports